<template>
    <div class="mt-8">
        <div v-if="name === 'وزن'">
            <WidgetsProductWeightSelector
                :filter="name"
                :options="(options as any)"
                v-model="selectedVariants[name]"
                :deactivate-indexes="deactivateIndexes"
                @update="handleUpdate"
            />
        </div>
        <div v-else-if="name === 'درجه آسیاب'">
            <WidgetsProductGrindingGradeSelector
                :filter="name"
                :options="(options as any)"
                v-model="selectedVariants[name]"
                :deactivate-indexes="deactivateIndexes"
                @update="handleUpdate"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { ModelRef } from "vue";
import type { IDynamicKey } from "~/libs/types/general";

const emits = defineEmits(["update"]);

const props = defineProps({
    name: [String, Number],
    options: Array,
});

const selectedVariants: ModelRef<IDynamicKey<string>> = defineModel({ required: true });

const deactivateIndexes = ref([]);

// const variantsList = computed(() => {
//     if (props.variants) {
//         return chain(props.variants)
//             .flatMap((variant) => variant.variants)
//             .map((variant) => variant?.name)
//             .uniq()
//             .value();
//     }
//     return [];
// });

function handleUpdate(oldValue: any, newValue: any) {
    emits("update", oldValue, newValue);
}
</script>

<style></style>
